<div class="dashboard-content-container">

    <!-- TOP KPI ROW -->
    <div class="grid grid-cols-5 gap-3 mb-2 kpi-row">
        <div class="card kpi-card bg-blue dash-link" (click)="openList('total')">

          <div class="kpi-icon-square">
            <i class="fa-solid fa-layer-group"></i>
          </div>
          <div class="kpi-data">
            <span class="label">TOTAL PROJECTS</span>
            <span class="value">{{ formatKpiCount(stats().totalProjects) }}</span>
            <span class="subtitle">Across All Departments</span>
          </div>
        </div>

        <div class="card kpi-card bg-emerald dash-link" (click)="openList('sanctioned')">
          <div class="kpi-icon-square">
            <i class="fa-solid fa-indian-rupee-sign"></i>
          </div>
          <div class="kpi-data">
            <span class="label">SANCTIONED</span>
            <span class="value">{{ formatSpent(stats().totalSanctioned) }}</span>
            <span class="subtitle">{{ stats().totalProjects }} Projects Budget</span>
          </div>
        </div>

        <div class="card kpi-card bg-amber dash-link" (click)="openList('expenditure')">
          <div class="kpi-icon-square">
            <i class="fa-solid fa-chart-pie"></i>
          </div>
          <div class="kpi-data">
            <span class="label">EXPENDITURE</span>
            <span class="value">{{ formatSpent(stats().totalSpent) }}</span>
            <span class="subtitle">{{ expenditureProjectCount() }} Projects Active</span>
          </div>
        </div>

        <div class="card kpi-card bg-rose dash-link" (click)="navigateToDelayed()">
          <div class="kpi-icon-square">
            <i class="fa-solid fa-clock-rotate-left"></i>
          </div>
          <div class="kpi-data">
            <span class="label">DELAYED</span>
            <span class="value">{{delayedCardCount()}}</span>
            <span class="subtitle">OSD Flagged</span>
          </div>
        </div>

        <div class="card kpi-card bg-teal dash-link" (click)="openList('lastUpdated')">
          <div class="kpi-icon-square">
            <i class="fa-solid fa-rotate"></i>
          </div>
          <div class="kpi-data">
            <span class="label">LAST SYNC</span>
            <span class="value">{{ lastSyncDisplay() }}</span>
            <span class="subtitle">{{ lastSyncTime() }} · Live</span>
          </div>
        </div>
    </div>

    <!-- MAIN ANALYTICS SECTION (70/30) -->
    <div class="dashboard-analytics-grid">
      
      <!-- LEFT PANEL (75%) -->
      <div class="left-panel">
        
        <!-- DEPARTMENT WISE STATUS -->
        <div class="card">
          <div class="card-header-navy">
            <h3><i class="fa-solid fa-building-shield"></i> Department Wise Status</h3>
            <button class="view-all-btn mobile-view-all" (click)="openList('total')">View All</button>
          </div>
          <div class="dept-section-body">
            <div class="dept-table-hscroll custom-scroll">
              <table class="premium-enterprise-table dept-table">
                <thead>
                  <tr>
                    <th>Department</th>
                    <th class="text-center">Total Projects</th>
                    <th class="text-center">Delayed</th>
                    <th class="text-center">Critical</th>
                    <th class="text-center">Health</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of allDeptRows()" (click)="openDepartmentDetails(row.name)" class="cursor-pointer hover:bg-slate-50 transition-colors">
                    <td>
                      <div class="dept-cell">
                        <div class="dept-icon-box" [style.background]="row.color" [style.color]="'white'">
                          <i [class]="row.icon"></i>
                        </div>
                        <span class="dept-name-full">{{ row.name }}</span>
                        <span class="dept-name-short">{{ row.label }}</span>
                      </div>
                    </td>
                    <td class="text-center font-bold">{{ row.count }}</td>
                    <td class="text-center font-bold" [class.text-red-500]="row.delayed > 0" [class.text-slate-300]="row.delayed === 0">{{ row.delayed }}</td>
                    <td class="text-center font-bold" [class.text-red-600]="row.critical > 0" [class.text-slate-300]="row.critical === 0">{{ row.critical }}</td>
                    <td class="text-center">
                      <div class="health-badge" [class]="row.health.toLowerCase()">
                        <div class="dot"></div>
                        {{ row.health }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- PROJECTS REQUIRING IMMEDIATE INTERVENTION -->
        <div class="card intervention-card">
          <div class="card-header-navy">
            <h3><i class="fa-solid fa-triangle-exclamation"></i> Immediate Intervention</h3>
            <button class="view-all-btn mobile-view-all" (click)="openList('priorities')">View All</button>
          </div>
          @if (highVisibilityProjects().length === 0) {
            <div class="intervention-empty">
              <i class="fa-regular fa-circle-check" aria-hidden="true"></i>
              <p class="intervention-empty-title">No urgent interventions</p>
              <p class="intervention-empty-sub">All priority projects are on track. Tap View All to monitor flagged items.</p>
            </div>
          } @else {
          <div
            class="table-scroll-container intervention-table-wrap custom-scroll"
            [style.max-height.px]="interventionTableMaxHeight()">
            <table class="premium-enterprise-table intervention-table">
              <thead>
                <tr>
                  <th style="width: 35%">Project Name</th>
                  <th>Dept</th>
                  <th class="text-center">Delay</th>
                  <th>Reason</th>
                  <th>Budget</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of highVisibilityProjects()">
                  <td><span class="font-bold text-slate-700">{{ p.name }}</span></td>
                  <td><span class="text-[10px] font-bold text-slate-500 uppercase">{{ p.dept }}</span></td>
                  <td class="text-center"><span class="text-red-600 font-bold">120d</span></td>
                  <td><span class="text-slate-500 italic text-[11px]">Land issue</span></td>
                  <td><span class="font-bold text-slate-600">₹{{ (p.cost / 10000000).toFixed(1) }}Cr</span></td>
                  <td class="text-center">
                    <button (click)="openProjectDetails(p.id)" class="text-blue-500 hover:text-blue-700 p-1">
                      <i class="fa-solid fa-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          }
        </div>
      </div>

      <!-- RIGHT PANEL (25%) -->
      <div class="right-panel">
        
        <!-- HM PROJECTS SUMMARY -->
        <div class="card widget-card">
          <h4 class="widget-title">HM Summary</h4>
          <div class="donut-chart-container dash-link" (click)="openList('hmTotal')">
            <canvas id="hmProjectsChart"></canvas>
            <div class="chart-center-text">
              <span class="total-num">{{ hmStats().total }}</span>
              <span class="total-lbl">Total HM</span>
            </div>

          </div>
          <div class="chart-legend-grid">
            <div class="legend-item dash-link" (click)="openList('hmOnTrack')"><div class="dot bg-emerald-500"></div> On Track ({{ hmStats().onTrackPct }}%) <span class="val">{{ hmStats().onTrack }}</span></div>
            <div class="legend-item dash-link" (click)="openList('hmAtRisk')"><div class="dot bg-amber-500"></div> At Risk ({{ hmStats().atRiskPct }}%) <span class="val">{{ hmStats().atRisk }}</span></div>
            <div class="legend-item dash-link" (click)="openList('hmDelayed')"><div class="dot bg-red-500"></div> Delayed ({{ hmStats().delayedPct }}%) <span class="val">{{ hmStats().delayed }}</span></div>
          </div>

        </div>

        <!-- QUICK ACTIONS -->
        <div class="card widget-card">
          <h4 class="widget-title">Quick Actions</h4>
          <div class="quick-actions-list">
            <a (click)="openList('priorities')" class="action-link cursor-pointer">
              <i class="fa-regular fa-star"></i> Priority Projects
              <span class="badge" *ngIf="priorityProjects().length > 0">{{ priorityProjects().length }}</span>
            </a>
            <a (click)="openList('recentUpdates')" class="action-link cursor-pointer">
              <i class="fa-regular fa-clock"></i> Recent Updates
            </a>
            <a (click)="openList('delayed60')" class="action-link cursor-pointer">
              <i class="fa-solid fa-circle-exclamation text-red-500"></i> Delayed > 60 Days
              <span class="badge danger" *ngIf="delayedMoreThan60() > 0">{{ delayedMoreThan60() }}</span>
            </a>
            <a (click)="openList('reports')" class="action-link cursor-pointer">
              <i class="fa-solid fa-download"></i> Reports
            </a>
          </div>
        </div>


        <!-- PROGRESS OVERVIEW -->
        <div class="card widget-card">
          <h4 class="widget-title">Progress Overview</h4>
          <div class="progress-grid">
            <div class="progress-mini-card completed dash-link" (click)="openList('completed')">
              <span class="lbl">Done</span>
              <span class="val">{{ progressStats().done }}</span>
            </div>
            <div class="progress-mini-card ongoing dash-link" (click)="openList('inProgress')">
              <span class="lbl">Active</span>
              <span class="val">{{ progressStats().active }}</span>
            </div>
            <div class="progress-mini-card delayed dash-link" (click)="openList('stuck')">
              <span class="lbl">Slow</span>
              <span class="val">{{ progressStats().slow }}</span>
            </div>
            <div class="progress-mini-card stuck dash-link" (click)="openList('planned')">
              <span class="lbl">Planned</span>
              <span class="val">{{ progressStats().planned }}</span>
            </div>
          </div>

          <div class="overall-progress-section dash-link" (click)="openList('total')">
            <div class="lbl-row">
              <span>Physical Progress</span>
              <span class="perc">{{ progressStats().avgPhys }}%</span>
            </div>
            <div class="bar-bg">
              <div class="bar-fill bg-blue-600" [style.width.%]="progressStats().avgPhys"></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- MOBILE HM SUMMARY CARD (mobile only, replaces hidden right panel) -->
    <div class="mobile-hm-card dash-link" (click)="openHmDrawer()">
      <div class="mobile-hm-left">
        <span class="mobile-hm-title"><i class="fa-solid fa-star"></i> HM Summary</span>
        <div class="mobile-hm-stats">
          <span class="mobile-hm-stat track"><i class="fa-solid fa-circle-check"></i> {{ hmStats().onTrack }} On Track</span>
          <span class="mobile-hm-stat risk"><i class="fa-solid fa-circle-exclamation"></i> {{ hmStats().atRisk }} At Risk</span>
          <span class="mobile-hm-stat late"><i class="fa-solid fa-circle-xmark"></i> {{ hmStats().delayed }} Delayed</span>
        </div>
      </div>
      <div class="mobile-hm-right">
        <span class="mobile-hm-total-num">{{ hmStats().total }}</span>
        <span class="mobile-hm-total-lbl">HM Projects</span>
        <span class="mobile-hm-tap"><i class="fa-solid fa-chevron-up"></i> Details</span>
      </div>
    </div>

    <!-- HM MOBILE DRAWER -->
    @if (isHmDrawerOpen()) {
      <div class="hm-drawer-overlay" (click)="closeHmDrawer()">
        <div class="hm-drawer" (click)="$event.stopPropagation()">
          <div class="hm-drawer-handle"></div>
          <div class="hm-drawer-header">
            <span class="hm-drawer-title"><i class="fa-solid fa-star"></i> HM Summary</span>
            <button class="hm-drawer-close" (click)="closeHmDrawer()">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div class="hm-drawer-body">
            <!-- Donut Chart -->
            <div class="hm-drawer-chart-row">
              <div class="donut-chart-container" (click)="openList('hmTotal')">
                <canvas id="hmProjectsChartMobile"></canvas>
                <div class="chart-center-text">
                  <span class="total-num">{{ hmStats().total }}</span>
                  <span class="total-lbl">Total HM</span>
                </div>
              </div>
              <div class="chart-legend-grid">
                <div class="legend-item dash-link" (click)="openList('hmOnTrack')"><div class="dot bg-emerald-500"></div> On Track ({{ hmStats().onTrackPct }}%) <span class="val">{{ hmStats().onTrack }}</span></div>
                <div class="legend-item dash-link" (click)="openList('hmAtRisk')"><div class="dot bg-amber-500"></div> At Risk ({{ hmStats().atRiskPct }}%) <span class="val">{{ hmStats().atRisk }}</span></div>
                <div class="legend-item dash-link" (click)="openList('hmDelayed')"><div class="dot bg-red-500"></div> Delayed ({{ hmStats().delayedPct }}%) <span class="val">{{ hmStats().delayed }}</span></div>
              </div>
            </div>
            <!-- Quick Actions -->
            <div class="hm-drawer-section">
              <h5 class="hm-drawer-section-title">Quick Actions</h5>
              <div class="quick-actions-list">
                <a (click)="openList('priorities')" class="action-link cursor-pointer">
                  <i class="fa-regular fa-star"></i> Priority Projects
                  <span class="badge" *ngIf="priorityProjects().length > 0">{{ priorityProjects().length }}</span>
                </a>
                <a (click)="openList('recentUpdates')" class="action-link cursor-pointer">
                  <i class="fa-regular fa-clock"></i> Recent Updates
                </a>
                <a (click)="openList('delayed60')" class="action-link cursor-pointer">
                  <i class="fa-solid fa-circle-exclamation text-red-500"></i> Delayed &gt; 60 Days
                  <span class="badge danger" *ngIf="delayedMoreThan60() > 0">{{ delayedMoreThan60() }}</span>
                </a>
                <a (click)="openList('reports')" class="action-link cursor-pointer">
                  <i class="fa-solid fa-download"></i> Reports
                </a>
              </div>
            </div>
            <!-- Progress Overview -->
            <div class="hm-drawer-section">
              <h5 class="hm-drawer-section-title">Progress Overview</h5>
              <div class="progress-grid">
                <div class="progress-mini-card completed dash-link" (click)="openList('completed')">
                  <span class="lbl">Done</span>
                  <span class="val">{{ progressStats().done }}</span>
                </div>
                <div class="progress-mini-card ongoing dash-link" (click)="openList('inProgress')">
                  <span class="lbl">Active</span>
                  <span class="val">{{ progressStats().active }}</span>
                </div>
                <div class="progress-mini-card delayed dash-link" (click)="openList('stuck')">
                  <span class="lbl">Slow</span>
                  <span class="val">{{ progressStats().slow }}</span>
                </div>
                <div class="progress-mini-card stuck dash-link" (click)="openList('planned')">
                  <span class="lbl">Planned</span>
                  <span class="val">{{ progressStats().planned }}</span>
                </div>
              </div>
              <div class="overall-progress-section dash-link" (click)="openList('total')">
                <div class="lbl-row">
                  <span>Physical Progress</span>
                  <span class="perc">{{ progressStats().avgPhys }}%</span>
                </div>
                <div class="bar-bg">
                  <div class="bar-fill bg-blue-600" [style.width.%]="progressStats().avgPhys"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- DYNAMIC PROJECT LIST MODAL -->
    @if (listFilter()) {
      <div class="dash-modal-overlay" (click)="closeList()">
        <div class="dash-modal-card" (click)="$event.stopPropagation()">
          <div class="dash-modal-header">
            <div>
              <h3>{{ listTitle() }}</h3>
              <p>{{ listProjects().length }} project(s)</p>
            </div>
            <div class="dash-header-actions">
              <div class="dash-view-toggle">
                <button class="dvt-btn" [class.dvt-active]="cardView()" (click)="toggleCardView(true)" title="Card view">
                  <i class="fa-solid fa-grip"></i>
                </button>
                <button class="dvt-btn" [class.dvt-active]="!cardView()" (click)="toggleCardView(false)" title="List view">
                  <i class="fa-solid fa-list"></i>
                </button>
              </div>
              <button class="dash-modal-close" (click)="closeList()">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>

          <div class="dash-modal-body">
            @if (listProjects().length === 0) {
              <div class="dash-empty">
                <i class="fa-solid fa-circle-check"></i>
                <p>No projects to show.</p>
              </div>
            } @else if (cardView()) {
              <div class="dpc-grid">
                @for (p of listProjects(); track p.id) {
                  <div class="dpc"
                    [class.dpc--completed]="p.status === 'Completed'"
                    [class.dpc--stuck]="p.status === 'Stuck'"
                    [class.dpc--inprogress]="p.status === 'In Progress'"
                    (click)="openProjectDetails(p.id); closeList()">
                    <div class="dpc__top">
                      <span class="dpc__dept">{{ p.dept }}</span>
                      <div class="dpc__badges">
                        @if (p.hmPriority) {
                          <span class="dpc__badge dpc__badge--hm"><i class="fa-solid fa-star"></i> HM</span>
                        }
                        @if (p.recurringIntervention) {
                          <span class="dpc__badge dpc__badge--rec"><i class="fa-solid fa-rotate"></i></span>
                        }
                        @if ($any(p).isDelayed) {
                          <span class="dpc__badge dpc__badge--delay"><i class="fa-solid fa-clock"></i></span>
                        }
                      </div>
                    </div>
                    <span class="dpc__status"
                      [class.dpc__status--completed]="p.status === 'Completed'"
                      [class.dpc__status--inprogress]="p.status === 'In Progress'"
                      [class.dpc__status--stuck]="p.status === 'Stuck'"
                      [class.dpc__status--planned]="p.status === 'Planned'">{{ p.status }}</span>
                    <p class="dpc__name">{{ p.name }}</p>
                    <div class="dpc__meta">
                      @if (p.loc) {
                        <span class="dpc__meta-chip"><i class="fa-solid fa-location-dot"></i> {{ p.loc }}</span>
                      }
                      @if (p.scheme) {
                        <span class="dpc__meta-chip"><i class="fa-solid fa-tag"></i> {{ p.scheme }}</span>
                      }
                    </div>
                    <div class="dpc__stats">
                      <div class="dpc__stat">
                        <span class="dpc__stat-lbl">Cost</span>
                        <span class="dpc__stat-val">₹{{ p.cost | number }}L</span>
                      </div>
                      <div class="dpc__stat">
                        <span class="dpc__stat-lbl">Spent</span>
                        <span class="dpc__stat-val">₹{{ p.spent | number }}L</span>
                      </div>
                      <div class="dpc__stat">
                        <span class="dpc__stat-lbl">Progress</span>
                        <span class="dpc__stat-val dpc__stat-val--prog">{{ p.physical || 0 }}%</span>
                      </div>
                    </div>
                    <div class="dpc__bar-wrap">
                      <div class="dpc__bar">
                        <div class="dpc__bar-fill"
                          [style.width.%]="p.physical || 0"
                          [class.dpc__bar-fill--completed]="p.status === 'Completed'"
                          [class.dpc__bar-fill--stuck]="p.status === 'Stuck'"
                          [class.dpc__bar-fill--inprogress]="p.status === 'In Progress'"></div>
                      </div>
                    </div>
                    <div class="dpc__footer">
                      <span class="dpc__view-hint"><i class="fa-solid fa-arrow-up-right-from-square"></i> View Details</span>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <table class="dash-modal-table">
                <thead>
                  <tr>
                    <th>Project</th>
                    <th>Dept</th>
                    <th>Status</th>
                    <th class="text-center">Progress</th>
                    <th class="text-right">Cost (₹L)</th>
                    @if (listFilter() === 'expenditure') {
                      <th class="text-right">Spent (₹L)</th>
                      <th class="text-center">Utilized %</th>
                    }
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (p of listProjects(); track p.id) {
                    <tr>
                      <td>{{ p.name }}</td>
                      <td>{{ p.dept }}</td>
                      <td>
                        <span class="status-pill" [class.stuck]="p.status === 'Stuck'" [class.completed]="p.status === 'Completed'" [class.inprogress]="p.status === 'In Progress'" [class.planned]="p.status === 'Planned'">{{ p.status }}</span>
                      </td>
                      <td class="text-center">{{ p.physical || 0 }}%</td>
                      <td class="text-right">{{ p.cost | number }}</td>
                      @if (listFilter() === 'expenditure') {
                        <td class="text-right exp-spent">{{ p.spent | number }}</td>
                        <td class="text-center">
                          <span class="exp-util-pill"
                            [class.exp-util--high]="p.cost > 0 && (p.spent / p.cost) >= 0.75"
                            [class.exp-util--mid]="p.cost > 0 && (p.spent / p.cost) >= 0.4 && (p.spent / p.cost) < 0.75"
                            [class.exp-util--low]="p.cost > 0 && (p.spent / p.cost) < 0.4">
                            {{ p.cost > 0 ? ((p.spent / p.cost) * 100 | number:'1.0-0') + '%' : '—' }}
                          </span>
                        </td>
                      }
                      <td class="text-center">
                        <button class="text-blue-500 hover:text-blue-700 p-1" (click)="openProjectDetails(p.id); closeList()">
                          <i class="fa-solid fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>

          <div class="dash-modal-footer">
            <button class="dash-btn-cancel" (click)="closeList()">Close</button>
          </div>
        </div>
      </div>
    }
</div>